'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Link", {
    enumerable: true,
    get: function() {
        return Link;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useLink = require("./useLink");
const _useLinkStylesstyles = require("./useLinkStyles.styles");
const _renderLink = require("./renderLink");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const Link = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useLink.useLink_unstable)(props, ref);
    (0, _useLinkStylesstyles.useLinkStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useLinkStyles_unstable')(state);
    return (0, _renderLink.renderLink_unstable)(state);
// Work around some small mismatches in inferred types which don't matter in practice
});
Link.displayName = 'Link';
